exports.parse = function (url) {
  var query
  var ret
  if (url) {
    ret = {}
    query = url.slice(url.indexOf('?') + 1)
    if (!query) {
      return {}
    }

    query = query.split('?')[0]
    query.split('&').forEach(function (pair) {
      var splited = pair.split('=')
      if (splited[0]) {
        if (splited[1]) {
          ret[splited[0]] = decodeURIComponent(splited[1])
        } else {
          ret[splited[0]] = ''
        }
      }
    })
  } else {
    ret = {}
  }

  return ret
}

function wrapWithHash(func) {
  return (origin, ...params) => {
    let hash
    if (origin.includes('#')) {
      let hashSplitted = origin.split('#')
      origin = hashSplitted[0]
      hash = hashSplitted[1]
    }
    let result = func(origin, ...params)
    if (hash) {
      result += '#' + hash
    }
    return result
  }
}

exports.append = wrapWithHash(function (origin, obj) {
  var splited = origin.split('?')
  var base = splited[0]

  var qs = splited[1] ? '?' + splited[1] : ''

  var params = exports.parse(qs)
  for (var k in obj) {
    params[k] = obj[k]
  }

  const _query = exports.stringify(params)
  if (!_query) {
    return base
  }
  return base + '?' + _query
})

exports.stringify = function (data) {
  var result = []
  for (var key in data) {
    if (data[key] !== undefined) {
      result.push(key + '=' + encodeURIComponent(data[key]))
    }
  }
  return result.join('&')
}

exports.delete = wrapWithHash(function (origin, key) {
  var splited = origin.split('?')
  var base = splited[0]
  var query = splited[1]
  if (!query) {
    return base
  }
  var params = '?' + splited[1]
  params = exports.parse(params)
  delete params[key]
  let result = base + '?' + exports.stringify(params)
  return result
})

if (process.browser) {
  exports.query = exports.parse(location.search)
} else {
  exports.query = {}
}



// WEBPACK FOOTER //
// ./src/mods/qs.js